var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 132,
    viewBox: "0 0 65 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.2909 82.7583L16.3656 81.942L17.2909 82.7583ZM18.075 38.933L19.0568 39.6805L18.075 38.933ZM64.0547 0.892824L49.8352 1.79277L57.7243 13.6572L64.0547 0.892824ZM6.48744 130.195C1.95795 122.774 1.50697 115.002 3.86066 107.145C6.22754 99.2443 11.4346 91.2619 18.2162 83.5746L16.3656 81.942C9.46677 89.7622 4.00717 98.0566 1.49664 106.437C-1.02708 114.862 -0.56617 123.376 4.38101 131.481L6.48744 130.195ZM18.2162 83.5746C21.0303 80.3847 21.8168 76.6072 21.6411 72.6923C21.4673 68.8207 20.3455 64.694 19.2436 60.7139C18.1244 56.6715 17.0241 52.7746 16.7449 49.1453C16.4684 45.5494 17.0127 42.3654 19.0568 39.6805L17.0933 38.1856C14.5558 41.5187 13.9805 45.3832 14.2844 49.3345C14.5857 53.2524 15.7659 57.4016 16.8652 61.3724C17.9818 65.4053 19.0167 69.2589 19.1757 72.8029C19.3329 76.3036 18.6283 79.3772 16.3656 81.942L18.2162 83.5746ZM19.0568 39.6805C27.825 28.1631 44.8447 15.4359 55.5088 8.05686L54.1045 6.02751C43.4619 13.3918 26.1289 26.317 17.0933 38.1856L19.0568 39.6805Z",
    fill: "url(#paint0_linear_3_12370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12370",
    x1: 53.4932,
    y1: 4.11993,
    x2: 86.7069,
    y2: 80.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480335,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStake);
export default __webpack_public_path__ + "static/media/active_stake.6b6413743293df8f9cc58ae6e8ef8a31.svg";
export { ForwardRef as ReactComponent };